import React from 'react';
import PropTypes from 'prop-types';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './previewBox.scss';

function PreviewBox({ togglePreview, handleSubmit, isNew }) {
  return (
    <div className={styles.previewBox}>
      <div
        className={`${styles.previewContentContainer} ${styleHelper.layoutMobileSidePadding}`}
      >
        <p className={styleHelper.titleSmPrimary}>
          Detta är endast en förhandsgranskning.
        </p>
        <div className={styles.buttonContainer}>
          <button
            className={`${styleHelper.btnPrimaryLg}`}
            type="button"
            onClick={togglePreview}
          >
            Tillbaka
          </button>
          <button
            className={`${styleHelper.btnPrimaryLg}`}
            type="button"
            onClick={handleSubmit}
          >
            {isNew ? 'Publicera' : 'Publicera ändringar'}
          </button>
        </div>
      </div>
    </div>
  );
}

PreviewBox.propTypes = {
  togglePreview: PropTypes.func,
  handleSubmit: PropTypes.func,
  isNew: PropTypes.bool,
};

export default PreviewBox;
